import enMessages from "../locales/en_UK.json";
import { LangConfig } from "../model";

export const EnLang: LangConfig = {
  messages: {
    ...enMessages,
  },
  locale: "en-UK",
};
